"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextHeadline = void 0;
var _createText = require("./createText");
const TextHeadline = (0, _createText.createText)('headline');
exports.TextHeadline = TextHeadline;